import Vue from "vue";
import Router from "vue-router";
import HomePage from "@/components/pages/HomePage";
import LoginPage from "@/components/pages/LandingPage";
import ProcessLogin from "@/components/pages/ProcessLogin";
import ProcessLogout from "@/components/pages/ProcessLogout";
import NewSubmission from "@/components/pages/NewSubmission";
import IpForm from "@/components/common/IpForm";
import IPView from "@/components/pages/IPView";
import BrowseIP from "@/components/pages/BrowseIP";
import ReviewSubmission from "@/components/pages/ReviewSubmission";
import MySubmission from "@/components/pages/MySubmission";
import RolesManager from "@/components/pages/RolesManager";
import CTTVManager from "@/components/pages/CTTVManager";
import AccountManager from "@/components/pages/AccountManager";
import IPViewAdmin from "@/components/pages/IPViewAdmin";
import Headlines from "@/components/pages/Headlines";
import ForbiddenPage from "@/components/pages/403";
import NotFoundPage from "@/components/pages/404";
import ManageBanner from "@/components/pages/ManageBanner";
import MasterData from "@/components/pages/MasterData";
import IdeasContest from "@/components/pages/IdeasContest";
import IdeasRecognition from "@/components/pages/IdeasRecognition";
import FinalFolder from "@/components/pages/FinalFolder";
import IdeasExamination from "@/components/pages/IdeasExamination";

import helper, {
  checkLogin, checkPermission,
  checkToken
} from '../common/helper'
import * as CONFIG from '../config/index';
import ActivityManager from "@/components/pages/ActivityManager";
Vue.use(Router);

export default new Router({
  // scroll to top
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [{
      path: "/home",
      name: "HomePage",
      component: HomePage,
      props: {
        showSelectSpace: true
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next);
      }
    },
    {
      path: "/new-submission",
      name: "ChooseIPType",
      component: NewSubmission,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next);
      }
    },
    {
      path: "/new-submission/:type",
      name: "NewSubmission",
      component: IpForm,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next);
      }
    },
    {
      path: "/edit-submission/:id",
      name: "EditSubmission",
      component: IpForm,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next);
      }
    },
    {
      path: "/admin/edit-submission/:id",
      name: "AdminEditSubmission",
      component: IpForm,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next);
      }
    },
    {
      path: "/ip-view/:id",
      name: "IPView",
      component: IPView,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next);
      }
    },
    {
      path: "/browse-ip/:type",
      name: "BrowseIP",
      component: BrowseIP,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next);
      }
    },
    {
      path: "/",
      name: "LoginPage",
      component: LoginPage,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        let check = await checkToken();
        if (check) {
          //window.location.href = `${CONFIG.CLIENT_URL}/#/home`;
          //alert(123456);
          next('/home');
        } else {
          next();
        }
      }
    },
    {
      path: "/process-login",
      name: "ProcessLogin",
      component: ProcessLogin,
      props: {
        showSelectSpace: false
      }
    },
    {
      path: "/process-logout",
      name: "ProcessLogout",
      component: ProcessLogout,
      props: {
        showSelectSpace: false
      }
    },
    {
      path: "/review-submission",
      name: "ReviewSubmission",
      component: ReviewSubmission,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        const check = helper.checkReviewSubmit();
        console.log(check);
        if (check) {
          await checkLogin(next);
        } else {
          next('forbidden');
        }
      }
    },
    {
      path: "/my-submission",
      name: "MySubmission",
      component: MySubmission,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next);
      }
    },
    {
      path: "/roles-manager",
      name: "RolesManager",
      component: RolesManager,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next, CONFIG.SCREEN_CODE.ROLE_MANAGER);
      }
    },
    {
      path: "/cttv-manager",
      name: "CTTVManager",
      component: CTTVManager,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next, CONFIG.SCREEN_CODE.CTTV_MANAGER);
      }
    },
    {
      path: "/account-manager",
      name: "AccountManager",
      component: AccountManager,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next, CONFIG.SCREEN_CODE.ACCOUNT_MANAGER);
      }
    },
    {
      path: "/admin/ip-view/:id",
      name: "IPViewAdmin",
      component: IPViewAdmin,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next, CONFIG.SCREEN_CODE.IP_VIEW_ADMIN);
      }

    },
    {
      path: "/headlines",
      name: "Headlines",
      component: Headlines,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next);
      }
    },
    {
      path: "/forbidden",
      name: "ForbiddenPage",
      component: ForbiddenPage,
      props: {
        showSelectSpace: false
      }
    },
    {
      path: "/not-found",
      name: "NotFoundPage",
      component: NotFoundPage,
      props: {
        showSelectSpace: false
      }
    },
    {
      path: "/master-data",
      name: "MasterData",
      component: MasterData,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next, CONFIG.SCREEN_CODE.MASTER_DATA);
      }
    },
    {
      path: "/manage-banner",
      name: "ManageBanner",
      component: ManageBanner,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next, CONFIG.SCREEN_CODE.BANNER_MANAGER);
      }
    },
    {
      path: "/activity_manager",
      name: "ActivityManager",
      component: ActivityManager,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next, CONFIG.SCREEN_CODE.LOG_ACTIVITY);
      }
    },
    {
      path: "/idea-contest",
      name: "IdeasContest",
      component: IdeasContest,
      props: {
        showSelectSpace: false
      },
        beforeEnter: async (to, from, next) => {
          await checkLogin(next, CONFIG.SCREEN_CODE.IDEA_CONTEST);
        }
    },
    {
      path: "/idea-examination",
      name: "IdeasExamination",
      component: IdeasExamination,
      props: {
        showSelectSpace: false
      },
      beforeEnter: async (to, from, next) => {
        await checkLogin(next, CONFIG.SCREEN_CODE.IDEA_EXAMINATION);
      }
    },
    {
      path: "/idea-recognition",
      name: "IdeasRecognition",
      component: IdeasRecognition,
      props: {
        showSelectSpace: false
      }
    },
    {
      path: "/final-folder",
      name: "FinalFolder",
      component: FinalFolder,
      props: {
        showSelectSpace: false
      },
        beforeEnter: async (to, from, next) => {
          if (Vue.$cookies.get('globalRoles') === 'true') {
            await checkLogin(next, CONFIG.SCREEN_CODE.FINAL_FOLDER);
          } else {
            next('/forbidden');
          }
        }
    },
    {
      path: "/headline",
      name: "Headlines",
      component: Headlines,
      props: {
        showSelectSpace: false
      },
      //   beforeEnter: async (to, from, next) => {
      //     await checkLogin(next, CONFIG.SCREEN_CODE.BANNER_MANAGER);
      //   }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js